import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, createStyles, Dialog, Grid, IconButton,
  makeStyles, Theme, Typography,Button, ButtonBase, useTheme, useMediaQuery
} from '@material-ui/core';
import { ArrowBack, ArrowDropDown } from '@material-ui/icons';

import {
  closeOverlayAndReset, UniversalSizeActiveScreen, updateCurrentScreen
} from '../redux/UIOverlayUniversalSizeRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { FareastButton, FareastButtonText, FareastButtonWhite } from './OverlayComponentButton';
import { BodyMeasurementDetailList, BodyMeasurements, BodyMeasurementsKey, CalculateClothingMeasurementsFromBodyMeasurements, ClothingType, FitType, GetKey2CategoryClothingSizeMeasurementValues, RoundClothingMeasurementsToHalfPoint, GetChangedClothingMeasurementsFromBodyMeasurementsUpdate } from 'common-ts/dist/models/UserMeasurements';
import { getSortKey, reorderItemCategories } from './OverlayViewPersonalSizeDetail';
import CategoryTabs from './OverlayViewPersonalSizeCategoryTabs';
import OverlayComponentCanvas from './OverlayComponentCanvasFitAnimation';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import React, { useEffect } from 'react';
import { UkuranBadanCardMini } from './PageProductDetailSizeOptions';
import CloseIcon from '@material-ui/icons/Close';
import { ClothingMeasurementDetailPanel, getClothingMeasurementsSubtext, getClothingMeasurementsRuler } from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { socket } from '../socket';
import { OfflineActiveScreen } from '../redux/UIOverlayOfflineRedux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(3),
      left: theme.spacing(2),
      borderRadius: '50%',
      padding: theme.spacing(1),
    },
    backButtonIcon: {
      padding: '0',
      color: 'black',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(5),
      padding: '1.2em 0em 1em',
    },
    resultIntro: {
      fontSize: '0.8em',
      fontWeight: 400,
    },
    resultTitle: {
      fontSize: '0.8em',
      fontWeight: 400,
    },
    resultImage: {
      width: '60%',
      margin: '0.7em 0em 0.3em 0em',
    },
    resultSubtitle: {
      fontSize: '0.9em',
      width: '70%',
      fontWeight: 500,
      textAlign: 'center',
    },
    resultAccordion: {
      marginTop: '0.5em',
      width: '100%',
    },
    accordionHeader: {
      backgroundColor: '#F2F2F2',
      minHeight: '2em',
      maxHeight: '2em',
      '&.Mui-expanded': {
        minHeight: '2em',
        maxHeight: '2em',
      },
      '& .MuiAccordionSummary-expandIcon': {
        color: 'black',
      },
    },
    accordionTitle: {
      fontSize: '0.8em',
      fontWeight: 600,
    },
    accordionContent: {
      backgroundColor: '#F8F8F8',
      display: 'flex',
      flexDirection: 'column',
    },
    detailSizes: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '0.5em',
    },
    detailItemTitle: {
      fontSize: '0.8em',
      fontWeight: 500,
    },
    detailItemMeasurements: {
      fontSize: '0.8em',
      fontWeight: 400,
    },
    bottomButtons: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '8px',
    },
    categoryClothTab: {
      position: 'absolute',
      left: `calc(50% - 25vw)`,
      textAlign: 'center',
      width: '50vw',
      height: '50vw',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: '0.3s',
    },
    scrollProductImages: {
      marginTop: '1vw',
      position: 'relative',
      width: '100%',
      height: '30vw',
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      overflowY: 'hidden',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }
  }),
);

interface VarietySliderComponentProps {
  isLoading: boolean
  title?: string
  displayImagesArray: string[]
  numOfProducts?: number
  customScrollProductHeight?: string
  customElementWidth?: string
  customFontSize?: string
}

export function VarietySliderComponent({ isLoading, displayImagesArray, numOfProducts, 
  customScrollProductHeight, customElementWidth, title, customFontSize }: VarietySliderComponentProps) {
  const classes = useStyles();

  return (
    <Box style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <Typography style={{
        fontSize: customFontSize ? customFontSize : '2.8vw',
        letterSpacing: '0.1vw',
        fontWeight: 500,
        color: '#232323',
      }}>
        {title || 'AKAN DIPAKAI UNTUK'}
      </Typography>
      {
        isLoading ? 
        <Box style={{
          marginTop: '2vw',
          position: 'relative',
          width: '100%',
          height: customScrollProductHeight ? customScrollProductHeight : '30vw',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <CircularProgress/> 
        </Box>:
        <Box className={classes.scrollProductImages} style={{
          height: customScrollProductHeight ? customScrollProductHeight : '30vw',
        }}>
          {
            displayImagesArray.map((value, index) => {
              return (
                <img
                src={value}
                alt={'img-' + value}
                style={{
                  padding: '0.6vw',
                  height: customElementWidth ? customElementWidth : '26.7vw',
                  // minWidth: customElementWidth ? customElementWidth : '17.8vw',
                }}
                />
              );
            })
          }
        </Box>
      }
      {
        numOfProducts ? 
        <Typography style={{
          fontSize: customFontSize ? customFontSize : '2.7vw',
          letterSpacing: '0.1vw',
          fontWeight: 300,
          color: '#808080',
          marginTop: '1vw'
        }}>
          {numOfProducts} PRODUK
        </Typography>:
        null
      }
    </Box>
  );
}

interface Props {
  bodyMeasurements: BodyMeasurements
  name: string
  firstClothingType: ClothingType
  firstFitType: FitType
  buttonTextType: 'result-create' | 'result-detail'
  useCloseButton?: boolean
  handleBack: () => void
  handleUbahUkuran?: () => void
  handleSubmit: () => void
  triggerList?: { // We determine the triggers at the start (as input)
    [key: string]: {
      clothingMeasurementsKey: string // Same as the key for this dictionary
      bodyMeasurementsKey: string // Same as the key for this dictionary
      triggerText: string
      triggerCallback: () => void
      showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
    }
  }
  lastUpdatedMeasurementsList?: BodyMeasurements
  isStoreScreen?: string
  forceCategoryTabIndex?: number
}

export default function UniversalSizeResult({ bodyMeasurements, name, handleBack, handleUbahUkuran, handleSubmit, useCloseButton=false, buttonTextType, firstClothingType, firstFitType, triggerList, lastUpdatedMeasurementsList, isStoreScreen, forceCategoryTabIndex=undefined }: Props) {
  const classes = useStyles();
  const [categoryTabIndex, setCategoryTabIndex] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [touchStartXValue, setTouchStartXValue] = React.useState(0);

  useEffect(() => {
    if (forceCategoryTabIndex !== undefined) {
      if (categoryTabIndex !== forceCategoryTabIndex) {
        setCategoryTabIndex(forceCategoryTabIndex);
        loadChange(forceCategoryTabIndex);
      }
    }
  }, [forceCategoryTabIndex, categoryTabIndex]);

  useEffect(() => {
    if (isStoreScreen) {
      socket.timeout(5000).emit('chat message', {
        currentStore: 'STORE1',
        currentScreen: OfflineActiveScreen.SizeResult,
        justUpdateCategoryTabIndex: true,
        categoryTabIndex: categoryTabIndex,
      });
    }
  }, [categoryTabIndex]);

  // const [touchStartXValue, setTouchStartXValue] = React.useState(0);

  // const loadChangeIncrement = (currentIndex: number, shiftAmount: number) => {
  //   const categoryTabs = document.getElementsByClassName(classes.categoryClothTab);

  //   for (let i = 0; i < categoryTabs.length; i++) {
  //     let categoryTab = categoryTabs[i] as HTMLElement;

  //     let currentKey = 'category-clothing-' + currentIndex;

  //     if (categoryTab.id < currentKey) {
  //       if ('category-clothing-' + (currentIndex - 1) === categoryTab.id) {
  //         categoryTab.style.transform = `translateX(${-100}%)`;
  //       } else {
  //         categoryTab.style.transform = `translateX(${-200}%)`;
  //       }
  //       categoryTab.style.scale = `0.9`;
  //       categoryTab.style.opacity = `0.6`;
  //     } else if (categoryTab.id === currentKey) {
  //       categoryTab.style.transform = `translateX(${shiftAmount}%)`;
  //       categoryTab.style.scale = `1.1`;
  //       categoryTab.style.opacity = `1.0`;
  //     } else {
  //       if ('category-clothing-' + (newIndex + 1) === categoryTab.id) {
  //         categoryTab.style.transform = `translateX(${100}%)`;
  //       } else {
  //         categoryTab.style.transform = `translateX(${200}%)`;
  //       }
  //       categoryTab.style.scale = `0.9`;
  //       categoryTab.style.opacity = `0.6`;
  //     }
  //   }
  // }
  const loadChange = (newIndex: number) => {
    setIsLoading(true);
    // get all categoryTabs
    const categoryTabs = document.getElementsByClassName(classes.categoryClothTab);

    for (let i = 0; i < categoryTabs.length; i++) {
      let categoryTab = categoryTabs[i] as HTMLElement;

      let currentKey = 'category-clothing-' + newIndex;

      if (categoryTab.id < currentKey) {
        if ('category-clothing-' + (newIndex - 1) === categoryTab.id) {
          categoryTab.style.transform = `translateX(${-100}%)`;
        } else {
          categoryTab.style.transform = `translateX(${-200}%)`;
        }
        categoryTab.style.scale = `0.9`;
        categoryTab.style.opacity = `0.6`;
      } else if (categoryTab.id === currentKey) {
        categoryTab.style.transform = `none`;
        categoryTab.style.scale = `1.1`;
        categoryTab.style.opacity = `1.0`;
      } else {
        if ('category-clothing-' + (newIndex + 1) === categoryTab.id) {
          categoryTab.style.transform = `translateX(${100}%)`;
        } else {
          categoryTab.style.transform = `translateX(${200}%)`;
        }
        categoryTab.style.scale = `0.9`;
        categoryTab.style.opacity = `0.6`;
      }
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }

  const productsDictionary = useAppSelector(state => state.productsList.productsDictionary);
  const productSizeAvailabilityDict = useAppSelector(state => state.productsList.productSizeAvailabilityDict);
  
  const key2ProductIdArray: string[][] = [];
  const key2ProductIdDisplayImagesArray: string[][] = [];
  const key2ProductIdArrayLengths: number[] = [];

  const {
    itemCategoriesMainText,
    itemCategoriesMainText2,
    itemCategoriesSubtext,
    itemCategoriesClothingType,
    itemCategoriesFitType,
  } = reorderItemCategories(firstClothingType, firstFitType);

  if (productsDictionary) {
    const startingProductIds = Object.keys(productsDictionary)
    .sort((a, b) => getSortKey(productsDictionary[a], productSizeAvailabilityDict?.[a]) > getSortKey(productsDictionary[b], productSizeAvailabilityDict?.[b]) ? 1 : -1)

    for (var i = 0; i < itemCategoriesMainText.length; i += 1) {
      const clothingTypeCurrent = itemCategoriesClothingType[i];
      const fitTypeCurrent = itemCategoriesFitType[i];
      const filteredArray = startingProductIds.filter((productId) => productsDictionary[productId].clothingType === clothingTypeCurrent && productsDictionary[productId].defaultFitType === fitTypeCurrent);
      key2ProductIdArray.push(filteredArray);
      key2ProductIdDisplayImagesArray.push(filteredArray.map((productId) => productsDictionary[productId].displayImage));
      key2ProductIdArrayLengths.push(filteredArray.length);
    }
  }

  const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(itemCategoriesClothingType[categoryTabIndex], 
    itemCategoriesFitType[categoryTabIndex], false);
  const rawClothingMeas = CalculateClothingMeasurementsFromBodyMeasurements(
    itemCategoriesClothingType[categoryTabIndex], 
    itemCategoriesFitType[categoryTabIndex],
    bodyMeasurements, RegularSizeValue.L);
  const currentClothingMeas = RoundClothingMeasurementsToHalfPoint(rawClothingMeas);

  const defaultKey2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Kaos, 
    FitType.SlimFit,false);
  const defaultClothingMeas = RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
    ClothingType.Kaos, 
    FitType.SlimFit,
    bodyMeasurements, RegularSizeValue.L));
  const currentUpdatedClothingMeasBody = GetChangedClothingMeasurementsFromBodyMeasurementsUpdate(lastUpdatedMeasurementsList ?? {}, bodyMeasurements, itemCategoriesClothingType[categoryTabIndex]);
  const subtextDict = getClothingMeasurementsSubtext("GENERAL", key2ClothSizeValues, currentClothingMeas);
  const sizeRulerDict = getClothingMeasurementsRuler("GENERAL", key2ClothSizeValues, rawClothingMeas);

  // WE USE BODY BASED RULER & SUBTEXT (THE C VALUES ARE COMPARED TO C_BODY VALUES) TO MAINTAIN CONSISTENCY
  const currentRawClothingMeasBody = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, bodyMeasurements, RegularSizeValue.L);
  const currentClothingMeasBody = RoundClothingMeasurementsToHalfPoint(currentRawClothingMeasBody);
  const key2ClothSizeValuesBody = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Body, FitType.RegularFit, false);
  const subtextDictBody = getClothingMeasurementsSubtext(ClothingType.Body, key2ClothSizeValuesBody, currentClothingMeasBody);
  const sizeRulerDictBody = getClothingMeasurementsRuler(ClothingType.Body, key2ClothSizeValuesBody, currentRawClothingMeasBody);

  if (isMdOrUp) {
    return (<>
      {
        useCloseButton ? 
        <Box style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
          onClick={handleBack}
        >
          <ButtonBase
            style={{
              backgroundColor: '#ffffff',
              color: '#232323',
              padding: '4px',
              borderRadius: '40px'
            }}>
            <CloseIcon/>
          </ButtonBase>
        </Box>:
        <Box
          className={classes.backButton}
          onClick={handleBack}
        >
          <IconButton className={classes.backButtonIcon}>
            <ArrowBack />
          </IconButton>
        </Box>
      }
      <Box className={classes.dialogContent} style={{marginTop: '0px'}}>
        <Box style={{
          width: '100%'
        }}>
          <CategoryTabs 
            categoriesMainText={itemCategoriesMainText} 
            categoriesMainText2={itemCategoriesMainText2} 
            categoriesSubtext={itemCategoriesSubtext} 
            categoriesProductAmount={key2ProductIdArrayLengths}
            onCategoryChange={(category) => {
              setCategoryTabIndex(category);
              loadChange(category);
            }} 
            currentCategoryValue={categoryTabIndex} />
        </Box>
  
        <Grid container>
        <Grid item xs={6}>
        <Box style={{
          // marginTop: '6vw',
          position: 'relative',
          width: '100%',
          height: '40vw',
          overflow: 'hidden',
          scale: '0.7',
          marginTop: '-125px',
        }} onTouchStart={(e) => {
          setTouchStartXValue(e.changedTouches[0].screenX);
        }} onTouchEnd={(e) => {
          const touchEndXValue = e.changedTouches[0].screenX;
  
          // NOT ENOUGH MOVEMENT TO BE CONSIDERED A SLIDE
          if (touchEndXValue - touchStartXValue > -50 && touchEndXValue - touchStartXValue < 50) {
            return;
          }
          
          if (touchEndXValue - touchStartXValue > 0) { // SLIDE LEFT
            const newLeftIndex = categoryTabIndex - 1 >= 0 ? categoryTabIndex - 1 : 0;
            if (newLeftIndex !== categoryTabIndex) {
              setCategoryTabIndex(newLeftIndex);
              loadChange(newLeftIndex);
            }
          } else { // SLIDE RIGHT
            const newRightIndex = categoryTabIndex + 1 < itemCategoriesMainText.length ? categoryTabIndex + 1 : itemCategoriesMainText.length - 1;
            if (newRightIndex !== categoryTabIndex) {
              setCategoryTabIndex(newRightIndex);
              loadChange(newRightIndex);
            }
          }
        }}>
          {
            itemCategoriesMainText.map((value, index) => {
              return (
                <Box
                id={'category-clothing-' + index}
                className={classes.categoryClothTab}
                style={{
                  scale: index === 0 ? '1.1' : '0.9',
                  opacity: index === 0 ? '1' : '0.6',
                  transform: `translateX(${index * 100}%)` // Added to remove "side movement on initialization"
                }} onClick={() => {
                  setCategoryTabIndex(index);
                  loadChange(index);
                }}>
                  <OverlayComponentCanvas
                  clothingType={itemCategoriesClothingType[index]}
                  fitType={itemCategoriesFitType[index]}
                  putAtTop={false}
                  scaleRatio={0.8}
                  incrementTogether={true}
                  goalFit={RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
                    itemCategoriesClothingType[index], itemCategoriesFitType[index],
                    bodyMeasurements, RegularSizeValue.L))}
                  canvasManualHeight='30vw'/>
                </Box>
              );
            })
          }
        </Box>
  
        <Box style={{marginTop: '-50px'}}>
        <VarietySliderComponent
          isLoading={isLoading}
          displayImagesArray={key2ProductIdDisplayImagesArray[categoryTabIndex]}
          numOfProducts={key2ProductIdArrayLengths[categoryTabIndex]}
          customScrollProductHeight={'12.5vw'}
          customElementWidth={'10.75vw'}
          customFontSize={'15px'}
        />
        </Box>
        </Grid>
  
        <Grid item xs={6}>
        <Box style={{
          margin: '70px 12px 10px 12px',
          padding: '12px 0px 12px 19px',
          // backgroundColor: '#efefef',
          borderRadius: '14px',
          border: '1px solid #dedede',
        }} onClick={() => {
          // SLIDE KE BAWAH AJA
          const element = document.getElementById("ubah-option-button");
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          }
        }}>
          <ClothingMeasurementDetailPanel
            clothingType={itemCategoriesClothingType[categoryTabIndex]}
            fitType={itemCategoriesFitType[categoryTabIndex]}
            allowEditing={false}
            currentClothingMeas={currentClothingMeas}
            currentClothingMeasUpdatedDict={currentUpdatedClothingMeasBody}
            currentClothingMeasSubtextDict={subtextDictBody}
            currentlyFetchingAvailability={false}
            isSizeWheel={true}
            sizeWheelDict={sizeRulerDictBody}
            triggerList={triggerList ? triggerList : undefined}
          />
        </Box>
        
        <Box className={classes.bottomButtons}>
          <Button id={'ubah-option-button'} style={{
            color: '#000000',
            backgroundColor: 'rgba(100, 100, 100, 0.0)',
            borderRadius: '30px',
            border: '1.4px solid black',
            padding: '8px 15px 4px 15px',
            fontSize: '11px',
            letterSpacing: '0.7px',
            margin: '10px 23px'
          }}
          onClick={handleUbahUkuran ? handleUbahUkuran : handleBack}
          >
            {buttonTextType === 'result-create' ? 'UBAH UKURAN' : 'UBAH UKURAN'}
          </Button>
          <Button style={{
            color: 'white',
            backgroundColor: '#121212',
            borderRadius: '30px',
            padding: '8px 15px 4px 15px',
            fontSize: '11px',
            letterSpacing: '0.7px',
            margin: '10px 23px'
          }}
          onClick={handleSubmit}
          >
            {buttonTextType === 'result-create' ? 'SIMPAN UKURAN' : 'SIMPAN'}
          </Button>
        </Box>
        </Grid>
        </Grid>
      </Box>
    </>);
  }

  return <>
    {
      useCloseButton ? 
      <Box style={{
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
        onClick={handleBack}
      >
        <ButtonBase
          style={{
            backgroundColor: '#ffffff',
            color: '#232323',
            padding: '4px',
            borderRadius: '40px'
          }}>
          <CloseIcon/>
        </ButtonBase>
      </Box>:
      <Box
        className={classes.backButton}
        onClick={handleBack}
      >
        <IconButton className={classes.backButtonIcon}>
          <ArrowBack />
        </IconButton>
      </Box>
    }
    <Box className={classes.dialogContent}>
      <Box style={{
        width: '100%'
      }}>
        <CategoryTabs 
          categoriesMainText={itemCategoriesMainText} 
          categoriesMainText2={itemCategoriesMainText2} 
          categoriesSubtext={itemCategoriesSubtext} 
          categoriesProductAmount={key2ProductIdArrayLengths}
          onCategoryChange={(category) => {
            setCategoryTabIndex(category);
            loadChange(category);
          }} 
          currentCategoryValue={categoryTabIndex} />
      </Box>


      <Box style={{
        marginTop: '6vw',
        position: 'relative',
        width: '100%',
        height: '50vw',
        overflow: 'hidden',
      }} onTouchStart={(e) => {
        setTouchStartXValue(e.changedTouches[0].screenX);
      }} onTouchEnd={(e) => {
        const touchEndXValue = e.changedTouches[0].screenX;

        // NOT ENOUGH MOVEMENT TO BE CONSIDERED A SLIDE
        if (touchEndXValue - touchStartXValue > -50 && touchEndXValue - touchStartXValue < 50) {
          return;
        }
        
        if (touchEndXValue - touchStartXValue > 0) { // SLIDE LEFT
          const newLeftIndex = categoryTabIndex - 1 >= 0 ? categoryTabIndex - 1 : 0;
          if (newLeftIndex !== categoryTabIndex) {
            setCategoryTabIndex(newLeftIndex);
            loadChange(newLeftIndex);
          }
        } else { // SLIDE RIGHT
          const newRightIndex = categoryTabIndex + 1 < itemCategoriesMainText.length ? categoryTabIndex + 1 : itemCategoriesMainText.length - 1;
          if (newRightIndex !== categoryTabIndex) {
            setCategoryTabIndex(newRightIndex);
            loadChange(newRightIndex);
          }
        }
      }}>
        {
          itemCategoriesMainText.map((value, index) => {
            return (
              <Box
              id={'category-clothing-' + index}
              className={classes.categoryClothTab}
              style={{
                scale: index === 0 ? '1.1' : '0.9',
                opacity: index === 0 ? '1' : '0.6',
                transform: `translateX(${index * 100}%)` // Added to remove "side movement on initialization"
              }} onClick={() => {
                setCategoryTabIndex(index);
                loadChange(index);
              }}>
                <OverlayComponentCanvas
                clothingType={itemCategoriesClothingType[index]}
                fitType={itemCategoriesFitType[index]}
                putAtTop={false}
                scaleRatio={0.8}
                incrementTogether={true}
                goalFit={RoundClothingMeasurementsToHalfPoint(CalculateClothingMeasurementsFromBodyMeasurements(
                  itemCategoriesClothingType[index], itemCategoriesFitType[index],
                  bodyMeasurements, RegularSizeValue.L))}
                canvasManualHeight='50vw'/>
              </Box>
            );
          })
        }
      </Box>

      <VarietySliderComponent
        isLoading={isLoading}
        displayImagesArray={key2ProductIdDisplayImagesArray[categoryTabIndex]}
        numOfProducts={key2ProductIdArrayLengths[categoryTabIndex]}
      />

      <Box style={{
        margin: '10px 12px',
        padding: '12px 0px 12px 19px',
        // backgroundColor: '#efefef',
        borderRadius: '14px',
        border: '1px solid #dedede',
      }} onClick={() => {
        // SLIDE KE BAWAH AJA
        const element = document.getElementById("ubah-option-button");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
      }}>
        <ClothingMeasurementDetailPanel
          clothingType={itemCategoriesClothingType[categoryTabIndex]}
          fitType={itemCategoriesFitType[categoryTabIndex]}
          allowEditing={false}
          currentClothingMeas={currentClothingMeas}
          currentClothingMeasUpdatedDict={currentUpdatedClothingMeasBody}
          currentClothingMeasSubtextDict={subtextDictBody}
          currentlyFetchingAvailability={false}
          isSizeWheel={true}
          sizeWheelDict={sizeRulerDictBody}
          triggerList={triggerList ? triggerList : undefined}
        />
      </Box>
      
      <Box className={classes.bottomButtons}>
        <Button id={'ubah-option-button'} style={{
          color: '#000000',
          backgroundColor: 'rgba(100, 100, 100, 0.0)',
          borderRadius: '30px',
          border: '1.4px solid black',
          padding: '8px 15px 4px 15px',
          fontSize: '11px',
          letterSpacing: '0.7px',
          margin: '10px 23px'
        }}
        onClick={handleUbahUkuran ? handleUbahUkuran : handleBack}
        >
          {buttonTextType === 'result-create' ? 'UBAH UKURAN' : 'UBAH UKURAN'}
        </Button>
        <Button style={{
          color: 'white',
          backgroundColor: '#121212',
          borderRadius: '30px',
          padding: '8px 15px 4px 15px',
          fontSize: '11px',
          letterSpacing: '0.7px',
          margin: '10px 23px'
        }}
        onClick={handleSubmit}
        >
          {buttonTextType === 'result-create' ? 'SIMPAN UKURAN' : 'SIMPAN'}
        </Button>
      </Box>

    </Box>
  </>
}